import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import HorizontalButton from "../../../components/HorizontalButton";
import MobileViewLayout from "../../../layouts/MobileViewLayout";

const imagesToPreload = [
  "/imoji/thumb_up_1.png",
  "/imoji/Confused.png",
  "/imoji/thumb_down_1.png",
];

const Incomeslab = () => {
  const params = useParams();
  return (
    <MobileViewLayout>
      <div className="px-4 d-flex flex-column  justify-content-center align-items-center ">
        <h2 className="text-black fs30 fw-bold text-center m-0 fs30 incomesLab-selection-heading">
          <Trans i18nKey={"financial_situation.question"} />
        </h2>
        <div className="w-100 d-flex flex-column gap-1">
          <HorizontalButton
            navigateTo={{
              pathname: `/${params.gender}/remotework`,
            }}
            label={t("financial_situation.range_30_50k")}
            className="income-slab-button-text fs18"
            imagesToPreload={imagesToPreload}
          />
          <HorizontalButton
            navigateTo={{
              pathname: `/${params.gender}/remotework`,
            }}
            label={t("financial_situation.range_50_100k")}
            className="income-slab-button-text fs18"
            imagesToPreload={imagesToPreload}
          />
          <HorizontalButton
            navigateTo={{
              pathname: `/${params.gender}/remotework`,
            }}
            label={t("financial_situation.range_above_100k")}
            className="income-slab-button-text fs18"
            imagesToPreload={imagesToPreload}
          />
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default Incomeslab;
